"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionMetadataResponseToJSON = exports.RosettaConstructionMetadataResponseFromJSONTyped = exports.RosettaConstructionMetadataResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionMetadataResponseFromJSON(json) {
    return RosettaConstructionMetadataResponseFromJSONTyped(json, false);
}
exports.RosettaConstructionMetadataResponseFromJSON = RosettaConstructionMetadataResponseFromJSON;
function RosettaConstructionMetadataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metadata': _1.RosettaConstructionMetadataResponseMetadataFromJSON(json['metadata']),
        'suggested_fee': !runtime_1.exists(json, 'suggested_fee') ? undefined : (json['suggested_fee'].map(_1.RosettaAmountFromJSON)),
    };
}
exports.RosettaConstructionMetadataResponseFromJSONTyped = RosettaConstructionMetadataResponseFromJSONTyped;
function RosettaConstructionMetadataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metadata': _1.RosettaConstructionMetadataResponseMetadataToJSON(value.metadata),
        'suggested_fee': value.suggested_fee === undefined ? undefined : (value.suggested_fee.map(_1.RosettaAmountToJSON)),
    };
}
exports.RosettaConstructionMetadataResponseToJSON = RosettaConstructionMetadataResponseToJSON;
//# sourceMappingURL=RosettaConstructionMetadataResponse.js.map